import {
    AuthTypes
} from '../ActionTypes/AuthTypes';

class AuthAction {

    static getUser = payload => {
        return {
            type: AuthTypes.GET_USER,
            payload: payload,
        };
    };

    static UpdateUserProfile = payload => {
        return {
            type: AuthTypes.UPDATE_USER_PROFILE,
            payload: payload,
        };
    };
    static NotificationSwitch = payload => {
        return {
            type: AuthTypes.NOTIFICATION_SWITCH,
            payload: payload,
        };
    };

    static isLogin = payload => {
        return {
            type: AuthTypes.LOGIN,
            payload: payload,
        };
    };

    static isLogout = payload => {
        return {
            type: AuthTypes.LOGOUT,
            payload: payload,
        };
    };

}

export default AuthAction;
